<template>
  <div style="overflow-x: hidden;overflow-y: auto; height: 100%;">
    <div class="page_header">
      <span class="page_title">{{$t('driverSignInOutRec.司机签到签退记录')}}</span>
      <div style="flex:1;text-align: right;">
        <quickQuery :isDownload="true" @handleQuery="onQuery" @quickQuery="onQuery" @download="onExport"
          style="text-align: right" :isNow="true" />
      </div>

    </div>
    <el-divider></el-divider>

    <!-- 数据表格 -->
    <div class="page_container">
      <el-table :data="tableData" v-loading="loading" stripe style="width: 100%;">
        <el-table-column prop="GroupName" :label="$t('driverSignInOutRec.分组')" min-width="100"></el-table-column>
        <el-table-column prop="CarNo" :label="$t('driverSignInOutRec.车牌号')" min-width="120"></el-table-column>
        <el-table-column prop="DriverName" :label="$t('driverSignInOutRec.司机姓名')" min-width="120"></el-table-column>
        <el-table-column prop="DriverIC" :label="$t('driverSignInOutRec.司机编号')" min-width="100"></el-table-column>
        <el-table-column prop="InTime" :label="$t('driverSignInOutRec.签到时间')" min-width="180"></el-table-column>
        <el-table-column prop="OutTime" :label="$t('driverSignInOutRec.签退时间')" min-width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.OutTime || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="InPosition" :label="$t('driverSignInOutRec.签到位置')" min-width="200"></el-table-column>
        <el-table-column prop="OutPosition" :label="$t('driverSignInOutRec.签退位置')" min-width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.OutPosition || '-' }}</span>
          </template>
        </el-table-column>

      </el-table>
      <kl-pagination style="margin-bottom: 10px;" :pageSize="form.PageSize" :total="total" @current-change="pageChange"
        :current-page.sync="form.PageNo">
      </kl-pagination>
    </div>


  </div>
</template>

<script>
import quickQuery from "../components/generalOrQuickQuery.vue";
import { queryDriverSignRec } from '@/http/oil'
import language from '@/utils/getLanguageId';
import { mapState } from 'vuex'
export default {
  name: 'DriverSignInOutRec',
  components: {
    quickQuery
  },
  computed: {
    LanguageId() {
      return language(this.$store.getters.locale)
    },
    ...mapState({
      selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
  },
  data() {
    return {
      // 搜索表单
      form: {
        PageNo: 1,
        PageSize: 10
      },
      loading: false,
      beginDate: undefined,
      endDate: undefined,
      // 表格数据
      tableData: [],
      total: 0,

    }
  },
  mounted() {

  },
  methods: {
    getSelectedVehicles() {
      let vehicles = "";
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        if (this.selectedVehicles[k].treeLevel == 5) {
          vehicles = vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return vehicles.substring(0, vehicles.length - 1);
    },
    onExport() {

      //数据导出
      this.loadData(1);
    },
    onQuery(val) {
      this.beginDate = val.beginDate;
      this.endDate = val.endDate;
      this.loadData();
    },
    // 加载数据
    loadData(isExport) {
      isExport = isExport || 0;
      this.loading = true

      // 实际项目中取消注释以下代码
      queryDriverSignRec({
        "BeginDate": this.beginDate + " 00:00:00",
        "Language": this.LanguageId,
        "EndDate": this.endDate + " 23:59:59",
        "IsExport": isExport,
      "PageNo": this.form.PageNo, "PageSize": this.form.PageSize
      }, isExport == 1 ? 'blob' : 'json').then(res => {
        this.loading = false
        if (isExport == 1) {
          let blob = new Blob([res], {
            type: "application/vnd.ms-excel;charset=utf-8",
          }); // 重点代码

          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.download = this.$t('driverSignInOutRec.司机签到签退记录') + '.xlsx'; // 默认文件名
          // a.setAttribute(
          //     "download",
          //     "充电记录.xlsx"
          // ); // 表名，自定义
          // document.body.appendChild(a);
          a.click(); // 执行下载
          window.URL.revokeObjectURL(blob); // 释放ur
          // window.open(settings.baseUrl + "longyi/xlsx/" + res.data)
        } else {

          this.tableData = res.data || []
          this.total = res.count || 0

        }
      })



    },
    // 分页变化
    pageChange(page) {
      this.form.PageNo = page;
      this.loadData();
    },
  }
}
</script>

<style scoped>
/* 响应式设计 */

</style>